/* 🤖 this file was generated by svg-to-ts */
export const siriusUserMinus: {
  name: 'user_minus';
  data: string;
} = {
  name: 'user_minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.518 14.773a6.375 6.375 0 1 0-6.786 0 11.249 11.249 0 0 0-5.225 3.495.75.75 0 0 0 1.149.964 9.75 9.75 0 0 1 14.938 0 .75.75 0 1 0 1.15-.964 11.25 11.25 0 0 0-5.226-3.495ZM10.125 4.5a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75Z" fill="currentColor"/><path d="M18 12.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z" fill="currentColor"/></svg>`
};
